/* global ghwp */
import GLightbox from 'glightbox/src/js/glightbox';
import { FixLightboxPlaceholders } from './glightbox-usercentrics';

const plyrOptions = {
    js: ghwp.plyrScriptUrl,
    css: ghwp.plyrStyleUrl,
    config: {
        iconUrl: ghwp.plyrIconUrl,
    },
};

/**
 * @param selector
 * @return {GLightbox}
 */
export const stageVideo = (selector = '.sp-video') => {
    const hasStageVideo = document.querySelector('.sp-video');

    if (hasStageVideo && window.matchMedia('(min-width: 576px)').matches) {
        const lightbox = new GLightbox({
            selector,
            autoplayVideos: false,
            plyr: plyrOptions,
        });

        lightbox.on('open', async () => {
            // wait half a second for the entire lightbox to initialize
            await new Promise(res => setTimeout(() => res(), 500));
            new FixLightboxPlaceholders();
        });

        return lightbox;
    }
};
